import React, { useMemo } from 'react';

import { Typography } from '@mui/material';

import Hljs from 'main/components/Hljs';
import isEmpty from 'utils/is-empty';

import useStyles from './styles';

interface Props {
    cnaAffected: object | null | undefined;
}

const CnaAffected: React.FC<Props> = ({ cnaAffected }) => {
    const { classes } = useStyles();
    const text = useMemo(() => (isEmpty(cnaAffected) ? '' : JSON.stringify(cnaAffected, null, 2)), [cnaAffected]);

    if (!text || isEmpty(text)) {
        return null;
    }

    return (
        <div className={classes.root}>
            <Typography variant="h2" className={classes.title}>
                {'CNA Affected'}
            </Typography>
            <div className={classes.wrapper}>
                <div className={classes.code}>
                    <Hljs language={'json'}>{text}</Hljs>
                </div>
            </div>
        </div>
    );
};

export default CnaAffected;
